module.exports = __webpack_public_path__ + "static/media/4.c0e21c0c.jpg";